import * as React from 'react';
import MuiTextField from '@mui/material/TextField';
import useInputVariant from '../../Hooks/useInputVariant';
import { CommonPropsAndTypes } from '../_Types/StandardComponentProps';

interface IProps {
  type?: 'text' | 'number';
  id: string;
  value?: number;
  label: any;
  helperText?: string;
  error?: boolean;
  autoFocus?: boolean;
  disableAnimation?: boolean;
  onChange: (newValue: number | null) => void;
  disabled?: boolean;
  variant?: CommonPropsAndTypes.InputVariantType;
  testId?: string;
  className?: string;
}

interface IState {
  displayText: string;
}

export class EDNumericEdit extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      displayText: this.props.value != null ? this.props.value.toString() : '',
    };
  }

  // Todo: use componentDidUpdate instead <-- detta utgår, läs nedan...
  /*
   * TODO: refactor enligt https://reactjs.org/blog/2018/03/27/update-on-async-rendering.html
   *       där componentWillReceiveProps, componentWillMount och componentWillUpdate är märkta som obsoleta.
   *       UNSAFE_fungerar som migrationsverktyg, men är inte en permanent löstning.
   */
  UNSAFE_componentWillReceiveProps(nextProps: IProps) {
    if (this.props.value !== nextProps.value) {
      this.setDisplayText(
        // TODO: Format text
        nextProps.value != null ? nextProps.value.toString() : ''
      );
    }
  }

  setDisplayText = (newText: string) => {
    this.setState({ displayText: newText });
  };

  onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.setDisplayText(event.target.value);
  };

  onBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    const parsedValue = parseFloat(event.target.value.replace(',', '.'));
    this.setDisplayText(isNaN(parsedValue) ? '' : parsedValue.toString());
    this.props.onChange(isNaN(parsedValue) ? null : parsedValue);
  };

  render() {
    return (
      <MuiTextField
        key={this.props.id}
        type={this.props.type}
        name={this.props.id}
        value={this.state.displayText != null ? this.state.displayText : ''}
        onChange={this.onChange}
        label={this.props.label}
        fullWidth
        margin={'none'}
        helperText={this.props.helperText}
        error={this.props.error}
        onBlur={this.onBlur}
        autoFocus={this.props.autoFocus}
        InputLabelProps={{ disableAnimation: this.props.disableAnimation }}
        disabled={this.props.disabled}
        className={this.props.className}
        variant={this.props.variant || 'filled'}
        data-testid={this.props.testId}
        size="small"
      />
    );
  }
}

const EDEnhancedNumericEdit: React.FC<
  React.PropsWithChildren<IProps>
> = props => {
  const inputVariant = useInputVariant();

  return <EDNumericEdit variant={inputVariant} {...props} />;
};

export default EDEnhancedNumericEdit;
